function addGloboMegaMenuWidescreenClassToNav() {
  const navElement = document.querySelector('nav.header__primary-nav'); // Select your nav element
  const screenWidth = window.innerWidth || document.documentElement.clientWidth;

  // Check if screen width is greater than 999px
  if (screenWidth > 999) {
    navElement.classList.add('custom-globo-menu-desktop-view');
  } else {
    navElement.classList.remove('custom-globo-menu-desktop-view');
  }
}

// Initial check when the script loads
addGloboMegaMenuWidescreenClassToNav();

// Add event listener to check on window resize
window.addEventListener('resize', addGloboMegaMenuWidescreenClassToNav);